import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import bsaDataService from "./bsaDataService";
import { setAlertError } from "../alert/alertSlice";

const initialState = {
  districts: [],
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: "",
};

export const fetchDistricts = createAsyncThunk(
  "bsaData/fetchDistricts",
  async (_, thunkAPI) => {
    try {
      const response = await bsaDataService.getDistricts();
      return response;
    } catch (error) {
      const errData = error.response?.data || null;
      const err =
        errData?.message || error.message || "Failed to fetch districts";
      thunkAPI.dispatch(setAlertError(err));
      return thunkAPI.rejectWithValue(errData);
    }
  },
);

export const bsaDataSlice = createSlice({
  name: "bsaData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDistricts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchDistricts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        // Handle both response formats
        const districtsData =
          action.payload.data?.districts ||
          action.payload.districts ||
          action.payload ||
          [];
        state.districts = Array.isArray(districtsData) ? districtsData : [];
        console.log("Districts loaded:", state.districts);
      })
      .addCase(fetchDistricts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.districts = [];
        state.message = action.payload;
      });
  },
});

export default bsaDataSlice.reducer;
